import { render, staticRenderFns } from "./AchievementDetail.vue?vue&type=template&id=3f4053ba&scoped=true"
import script from "./AchievementDetail.vue?vue&type=script&lang=js"
export * from "./AchievementDetail.vue?vue&type=script&lang=js"
import style0 from "./AchievementDetail.vue?vue&type=style&index=0&id=3f4053ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4053ba",
  null
  
)

export default component.exports